import productApi from '../../../service/modules/product.api';

/**
 * Busca um produto especifico por ID
 *
 * @param {string} productId 
 * @returns {Promise<Object>} 
 */
export const fetchProductById = async (productId) => {
  try {
    const response = await productApi.getById(productId);

    return {
      success: true,
      data: response.data?.data,
    };
  } catch (error) {
    console.error(`❌ [ACTION] Erro ao buscar produto ${productId}:`, error);
    return {
      success: false,
      error: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

/**
 * Busca produtos.
 *
 * @param {Object} user
 * @param {{ unscoped?: boolean }} [options]
 *   unscoped=true → catálogo completo (só frete), sem filtro uidShipper
 * @returns {Promise<Object>}
 */
export const fetchProductGetAll = async (user, options = {}) => {
  try {
    const idUser = user?.uid || '';
    const params = { idUser };
    if (options.unscoped === true) {
      params.scope = 'all';
    }
    const response = await productApi.getAll(params);
    const products = Array.isArray(response?.data?.data) ? response.data.data : [];

    return {
      success: true,
      data: products,
    };
  } catch (error) {
    console.error('❌ [ACTION] Erro ao buscar produtos:', error);
    return {
      success: false,
      error: error.response?.data?.message || error.message,
      data: [],
    };
  }
};

/**
 * Cria um novo produto
 *
 * @param {Object} productData 
 * @returns {Promise<Object>} 
 */
export const createProduct = async (productData) => {
  try {
    if (!productData.product) {
      throw new Error('Nome do produto é obrigatório');
    }

    const response = await productApi.create(productData);

    return {
      success: true,
      data: response.data,
      message: 'Produto criado com sucesso!',
    };
  } catch (error) {
    console.error('❌ [ACTION] Erro ao criar produto:', error);
    return {
      success: false,
      error: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

/**
 * Atualiza um produto existente
 *
 * @param {string} productId - ID do produto
 * @param {Object} productData - Dados atualizados
 * @returns {Promise<Object>} Produto atualizado
 */
export const updateProduct = async (productId, productData) => {
  try {
    const response = await productApi.update(productId, productData);

    return {
      success: true,
      data: response.data,
      message: 'Produto atualizado com sucesso!',
    };
  } catch (error) {
    console.error(`❌ [ACTION] Erro ao atualizar produto ${productId}:`, error);
    return {
      success: false,
      error: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

/**
 * Deleta um produto
 *
 * @param {string} productId - ID do produto a deletar
 * @returns {Promise<Object>} Resultado da operacao
 */
export const deleteProductById = async (productId) => {
  try {
    await productApi.delete(productId);

    return {
      success: true,
      message: `Produto ${productId} deletado com sucesso!`,
    };
  } catch (error) {
    console.error(`❌ [ACTION] Erro ao deletar produto ${productId}:`, error);
    return {
      success: false,
      error: error.response?.data?.message || error.message,
    };
  }
};
